﻿import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  background: "rgba(63, 81, 181, 0.08)",
  padding: "0.94em 0.71em",
}));

type CardHeaderContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used in the main Container for styling the header items
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardHeaderContainer = ({ children, ...rest}: CardHeaderContainerProps) => {
  return <Root container justifyContent={'space-between'} alignItems={'center'} gap={2} {...rest}>
    { children }
  </Root>
}

export { CardHeaderContainer };
